import { Grid, Tooltip, useMediaQuery, useTheme } from "@material-ui/core";
import { Block } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import TableComponent from "app/common/Component/Table/TableComponent";
import { getDateTime, getGender, hideMiddleDigits } from "app/common/LocalFunction";
import { observer } from "mobx-react";
import React, { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import SaveIcon from "@material-ui/icons/Save";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import { toast } from "react-toastify";
import CopyableCodeCell from "app/common/Component/CopyableCodeCell";
import { COMPLAIN_STATUS } from "app/common/LocalConst";

const PopupDuplicatePatientByPhones = ({
  open,
  handleClose,
  duplicatePatients,
  onSelectPatient,
}) => {
  const { t } = useTranslation();
  const [selectedRow, setSelectedRow] = useState([]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const handleCloseWithValidation = () => {
    if (!selectedRow?.[0]) {
      toast.warning(
        "Không được đóng khi chưa chọn khách hàng trong danh sách!"
      );
      return;
    }
    handleClose();
  };
  console.log("duplicatePatients", duplicatePatients);
  return (
    <PopupForm
      open={open}
      size="lg"
      handleClose={handleCloseWithValidation}
      title={`Danh sách khách hàng trùng thông tin check in`}
      formik={{}}
      action={
        <div className="flex-center gap-1">
          <CommonButton
            className="btn-primary"
            onClick={() => {
              handleClose();
            }}
          >
            {!isMobile && <SaveIcon className="mr-2" />}
            Cập nhật lại SĐT
          </CommonButton>
          <CommonButton
            className="btn-add"
            onClick={() => {
              if (!selectedRow?.[0]) {
                toast.warning("Vui lòng chọn một khách hàng trong danh sách!");
                return;
              }
              onSelectPatient(selectedRow?.[0]);
            }}
          >
            {!isMobile && <SaveIcon className="mr-2" />}
            Chọn khách hàng check in
          </CommonButton>
        </div>
      }
    >
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <h5>
            <strong style={{ color: "red" }}>{open?.responseDetail}</strong>
          </h5>
        </Grid>
        <Grid item xs={12}>
          <TableComponent
            data={duplicatePatients || []}
            titleNodata={t("noData")}
            showOrdinalNumbers
            selectType={"single"}
            initStateRow={selectedRow}
            minWidth={800}
            handleChangeSelectedRows={(row) => setSelectedRow(row)}
            columns={[
              {
                field: "displayName",
                title: t("Tên khách hàng"),
                render: (patient) => (
                  <Tooltip title="Thông tin khách hàng">
                    <div>
                      <p>
                        <b>{patient?.displayName}</b>
                      </p>
                      <p>
                        {patient?.gender && (
                          <>
                            <span style={{ color: "#006778" }}>
                              <CopyableCodeCell value={patient?.code} size="small" />
                            </span>{" "}
                            | {getGender(patient?.gender)}
                          </>
                        )}
                      </p>
                    </div>
                  </Tooltip>
                ),
              },
              {
                field: "modifyDate", // hoặc field phù hợp hơn
                title: t("Ngày tạo"),
                render: (patient) => getDateTime(patient?.patientCreateDate),
              },
              {
                field: "phoneNumber",
                title: t("Số điện thoại"),
                align: "center",
                render: (data) => {
                  return (
                    <>
                      <div>
                        {data?.phoneNumber && <>SĐT 1: {hideMiddleDigits(data?.phoneNumber)} </>}
                        {data?.isMainPhoneNumber ? <>✔️</> : <></>}
                      </div>
                      <div>
                        {data?.subPhoneNumber && (
                          <>SĐT 2: {hideMiddleDigits(data?.subPhoneNumber)} </>
                        )}
                      </div>
                      <div>
                        {data?.phoneNumber3 && (
                          <>SĐT 3: {hideMiddleDigits(data?.phoneNumber3)} </>
                        )}
                      </div>
                      <div>
                        {data?.phoneNumber4 && (
                          <>SĐT 4: {hideMiddleDigits(data?.phoneNumber4)} </>
                        )}
                      </div>
                    </>
                  );
                },
              },
              {
                field: "currentTelesale.staffName",
                title: t("Telesale hiện thời"),
              },
              {
                field: "checkin",
                title: t("Trạng thái khiếu nại"),
                align: "center",
                render: (val) => {
                  const status = COMPLAIN_STATUS.find(
                    (el) => el?.value === val?.complainStatus
                  );
                  return (
                    <div className="flex justify-center">
                      <Tooltip title={status?.name || ""}>
                        <div className="flex align-center">
                          {status?.icon}
                          {isMobile && (
                            <span className="ml-1">{status?.name}</span>
                          )}
                        </div>
                      </Tooltip>
                    </div>
                  );
                },
              },
            ]}
          />
        </Grid>
      </Grid>
    </PopupForm>
  );
};

export default memo(observer(PopupDuplicatePatientByPhones));
